import cn from 'classnames'
import { translatePaymentMethodName } from 'mmfintech-commons'

import { PaymentMethodImage } from './PaymentMethodImage'

import CheckedIcon from '@assets/icons/checkout-checked-icon.svg'

type PaymentMethodButtonProps = {
  name: string
  selected: boolean
  onClick: () => void
}

export const PaymentMethodButton = ({ name, selected, onClick }: PaymentMethodButtonProps) => (
  <div className={cn('payment-method-button-wrapper', { selected })} onClick={onClick} data-test={`method-${name}`}>
    <PaymentMethodImage method={name} className={cn({ selected })}>
      {selected && (
        <span className='method-checked'>
          <img src={CheckedIcon} alt='Checked' />
        </span>
      )}
    </PaymentMethodImage>
    {translatePaymentMethodName(name)}
  </div>
)
